import { useEffect } from 'react';
import type { Router } from '@remix-run/router';

const MTM_CONTAINER_URL = 'https://stats.birdsdessines.fr/js/container_aPCud0zj.js';

declare global {
    interface Window {
        _mtm: Record<string, unknown>[];
    }
}

export function useMatomo(router: Router) {
    useEffect(() => {
        const _mtm = window._mtm = window._mtm || [];
        _mtm.push({ 'mtm.startTime': new Date().getTime(), 'event': 'mtm.Start' });

        const d = document;
        const g = d.createElement('script');
        const s = d.getElementsByTagName('script')[0];
        g.async = true;
        g.src = MTM_CONTAINER_URL;
        s.parentNode!.insertBefore(g, s);

        let previousPath = window.location.pathname;
        const unsubscribe = router.subscribe((state) => {
            const newPath = state.location.pathname;
            if (state.navigation.state === 'idle' && newPath !== previousPath) {
                previousPath = newPath;
                window._mtm = window._mtm || [];
                window._mtm.push({ event: 'mtm.PageView' });
            }
        });

        return () => unsubscribe();
    }, [router]);
}
